<template>
    <div class="c-step">
        <div class="c-step__number">
            {{number}}
        </div>
        <h2 class="c-step__title">
            <slot></slot>
        </h2>
    </div>
</template>
<script>
export default {
    props:['number']
}
</script>
<style lang="scss">
    @import '../_variables.scss';
    .c-step{
        padding-bottom: 1rem;
        @media(min-width: 780px){
            padding-bottom: 0;
            display: flex;
            justify-content: flex-start;
        }
        &__number{
            color:$lazuri; 
            font-size: 8rem;
            font-weight: bold;
            text-align: center;
            margin: 0;
            padding: 0;
            @media(min-width: 1430px){
                font-size: 11.2rem;
            }
        }
        &__title{
            color: $black;
            font-size: 1.2rem;
            text-align: center;
            @media(min-width: 780px){
                padding: 2rem;
                font-size: 1.5rem;
                padding: 2.5rem 3rem;
                text-align: left;
            }
            @media(min-width: 1430px){
                font-size: 2.2rem;
                padding: 3rem 4rem;
            }
            &::before{
                content: ' ';
                display: block;
                width: 100%;
                max-width: 530px;
                min-width: 20vw;
                border-top: 2px solid $darkLazuri;
                margin-bottom: 1rem;
            }
        }
    }
</style>